import { Flex, FlexProps } from '@chakra-ui/react';
import { VentureDetailsTabs } from './components/VentureDetailsTabs';

const VentureDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <VentureDetailsTabs />
  </Flex>
);

export default VentureDetailsData;
